console.log('THIS SHOULD BE THE VERY FIRST', navigator.serviceWorker);